<template lang="html">
  <div>
    <tempplate v-if="ProcessNames.BAT_CHAMPIONSHIP">
      <process-response-videointerview-scene ref="process_layer" :questions="questions" @set_event_catcher="$emit('set_event_catcher', $event)"/>
    </template>
    <template v-else>
      <component :is="isIos || isSafari ? 'default_safari' : 'default'" ref="process_layer" :questions="questions" @set_event_catcher="$emit('set_event_catcher', $event)"/>
    </template>
  </div>
</template>

<style>
  .carousel {
    margin-right: 10px;
  }
</style>

<script>
  import ProcessNames from '@/process/names.js'
  import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js'
  import SceneProcess from './SceneProcess.vue'
  import SceneProcessSafari from './SceneProcessSafari.vue'
  /**
   *global component process-response-videointerview-scene is used to be able replace it by process components
   */
  export default {
    name: 'response-videointerview-scene',

    components: {
      default: SceneProcess, 
      default_safari: SceneProcessSafari
    },

    mixins: [SafariBrowserDetector],

    props: {
      questions: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      processName () {
        return this.$store.getters['process/getName']
      }
    }
  }
</script>
